import { useCallback, useState } from "react";

export const useTurboFooterReady = (shouldRenderTurboPayment: boolean, isCartUpdateInProgress: boolean) => {
    const [isTurboLoaded, setIsTurboLoaded] = useState(false);

    const onTurboLoaded = useCallback(() => {
        if (!isCartUpdateInProgress) {
            setIsTurboLoaded(true);
        }
    }, [isCartUpdateInProgress]);

    if ((!shouldRenderTurboPayment || isCartUpdateInProgress) && isTurboLoaded) {
        setIsTurboLoaded(false);
    }

    return {
        isTurboFooterReady: !shouldRenderTurboPayment || isTurboLoaded,
        onTurboLoaded,
    };
};
